export default __webpack_public_path__ + "static/badges-modal-04487552d9a804ed372b5d18046e8153.png";